import { create } from 'zustand';
import { formSlice, FormStoreType } from './formSlice';

export const createExtensionInteropStore = () =>
  create<FormStoreType>()((...args) => ({
    ...formSlice(...args),
  }));

export const useExtensionInteropStore = createExtensionInteropStore();
